import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Result } from 'antd';
import { useNavigate } from 'react-router-dom';
export function Forbidden() {
    const navigate = useNavigate();
    return (_jsx(Result, { status: '403', title: '403', subTitle: 'Sorry, you are not authorized to access this page.', extra: _jsx(Button, { type: 'primary', onClick: () => navigate(-1), children: "Go Back" }) }));
}
